// @flow

import * as React from 'react';

// @TODO: don't import from a private folder.

import { useTranslator } from '@gandi/translate';

import { Select } from 'gandi.react-form';
// eslint-disable-next-line @gandi/gandi/no-private-import
import type { Props as SelectProps } from 'gandi.react-form/dist/components/controls/Select';

import styles from './SelectLangRow.scss';

type Props = {
  values: SelectProps['values'],
  name: string,
  title: string,
  value: string,
  handleChange: (SyntheticInputEvent<>) => mixed,
};

const selectVariant = ['small', 'block'];

function SelectLangRow({ values, handleChange, name, value, title }: Props) {
  const { __ } = useTranslator();

  return (
    <Select
      className={styles.selectLang}
      value={value}
      values={values}
      variant={selectVariant}
      title={title}
      onChange={handleChange}
      placeholder={__('Select a language')}
      name={name}
    >
      {title}
    </Select>
  );
}

export default (React.memo<Props>(SelectLangRow): React.ComponentType<Props>);
